<section class="section">
  <header
    (click)="toggleExpanded()"
    (keydown.enter)="toggleExpanded()"
    (keydown.space)="toggleExpanded()"
    [ngClass]="expanded ? 'expanded' : 'collapsed'"
    tabindex="0"
    [title]="[(expanded ? 'Hide ' : 'Show ') + 'Conditions for this field']"
    >
    <mat-icon fontIcon="edit_calendar"></mat-icon>
    <h3>
      Conditions
      @if (hasChanged) {
        <span class="has-changed-indicator" title="Update field changes below">*</span>
      }
    </h3>
    <mat-icon fontIcon="expand_more" class="expand-icon"></mat-icon>
  </header>
  @if (expanded) {
    <section class="table-full-width" @configSectionsInOut>
      <p>Select a field, operator and value to filter by</p>
      @if (conditions.length === 0) {
        <ul class="conditions-list">
          <div class="no-conditions">NO CONDITIONS</div>
        </ul>
      }
      @if (conditions.length > 0) {
        <ul class="conditions-list scrollable-container">
          @for (condition of conditions; track $index) {
            <li
              (click)="onEditCondition(condition)"
              [title]="conditionTooltip(condition)"
              [ngClass]="{ editing: condition === editing }"
              >
              <section class="condition-labels">
                <div class="field" title="Field: {{ condition.fieldLabel }}">
                  {{ condition.fieldLabel }}
                </div>
                <div class="operator" title="{{ condition.operator.label }}">
                  {{ condition.operator.label }}
                </div>
                <div class="operand" title="Value: {{ condition.valueSummary }}">
                  {{ condition.valueSummary }}
                </div>
              </section>
              <aside>
                <mat-icon
                  class="edit-icon"
                  fontIcon="edit"
                  tabindex="0"
                  (keydown.enter)="onEditCondition(condition)"
                  (keydown.space)="onEditCondition(condition)"
                ></mat-icon>
                <mat-icon
                  class="remove-icon"
                  fontIcon="close"
                  tabindex="0"
                  title="Remove condition"
                  (click)="onRemoveCondition(condition)"
                  (keydown.enter)="onRemoveCondition(condition)"
                  (keydown.space)="onRemoveCondition(condition)"
                ></mat-icon>
              </aside>
            </li>
          }
        </ul>
      }
      <div class="conditions-grid">
        <mat-select
          class="field-filter full-width"
          [(ngModel)]="selField"
          placeholder="Choose a field..."
          title="The field to use to filter"
          (selectionChange)="onFieldSelected($event)"
          >
          @for (field of fields; track field.path) {
            <mat-option [value]="field">{{ field.label }}</mat-option>
          }
        </mat-select>
        <mat-select
          class="full-width"
          [(ngModel)]="operator"
          placeholder="Operator..."
          [title]="operator?.label"
          (selectionChange)="operatorChange()"
          [disabled]="!operator"
          >
          @for (op of operators; track op.op) {
            <mat-option [value]="op">{{ op.label }}</mat-option>
          }
        </mat-select>
        @if (selField && !isIncludeOperator) {
          @switch (selField.type) {
            @case (FieldType.DOUBLE) {
              <input
                type="number"
                class="full-width"
                placeholder="Enter a number..."
                title="The value to use to filter"
                [(ngModel)]="operand"
                />
            }
            @case (FieldType.INTEGER) {
              <input
                type="number"
                class="full-width"
                placeholder="Enter a number..."
                title="The value, without decimals to use to filter"
                pattern="\-?[0-9]+"
                [(ngModel)]="operand"
                />
            }
            @case (FieldType.DATE) {
              <input
                type="date"
                class="full-width"
                placeholder="Select a date..."
                title="The date to filter by"
                [(ngModel)]="operand"
                />
            }
            @case (FieldType.STRING) {
              <input
                type="text"
                class="full-width"
                placeholder="Empty string"
                title="The text to filter by"
                [(ngModel)]="operand"
                />
            }
            @case (FieldType.BOOLEAN) {
              <mat-select class="full-width" placeholder="Choose a value..." title="The value to filter by" [(ngModel)]="operand">
                <mat-option [value]="true">True</mat-option>
                <mat-option [value]="false">False</mat-option>
              </mat-select>
            }
          }
        }
        <!-- TODO: INSTEAD OF DEFAULTING AS A STRING - Add ew FieldType.ARRAY?-->
        <!-- TODO: Clear Chips when changing? (then don't need ngIf isIncludeOperator as well) -->
        @if (isIncludeOperator) {
          <div class="clear-input">
            <input
              type="text"
              class="full-width"
              placeholder="Enter value..."
              title="The text to filter by"
              (keydown.enter)="onAddChip(chipInput.value)"
              #chipInput
              />
              <i class="return-icon" [ngClass]="{ green: addingChip }" (click)="onAddChip(chipInput.value)" title="Hit 'Enter' to add"></i>
              <mat-icon
                class="clear-icon"
                fontIcon="close"
                (click)="clearInput(chipInput, true)"
                [title]="chipInput.value ? 'Clear' : ''"
              ></mat-icon>
            </div>
          }
          @if (!selField) {
            <input
              type="text"
              class="full-width"
              placeholder="Value to filter by"
              title="Choose a field first to interact with"
              disabled
              />
          }
        </div>
        @if (isIncludeOperator && chips.length > 0) {
          <div class="chips-container" @appearHeight>
            @for (chip of chips; track chip.label) {
              <button class="chip" [title]="chip.label ? '' : 'Empty value'" tabindex="-1" @appearWidth>
                {{ chip.label }}
                <mat-icon
                  class="remove-chip"
                  fontIcon="close"
                  title="Remove {{ chip.label }}"
                  (click)="onRemoveChip(chip)"
                  (keydown.enter)="onRemoveChip(chip)"
                  (keydown.space)="onRemoveChip(chip)"
                  tabindex="0"
                ></mat-icon>
              </button>
            }
          </div>
        }
        @if (!editing) {
          <button class="add-another-condition" [disabled]="!isValid()" theme="small" (click)="onAddOrUpdateCondition()">
            Add condition <mat-icon fontIcon="add"></mat-icon>
          </button>
        }
        @if (editing) {
          <button class="add-another-condition" [disabled]="!isValid()" theme="small" (click)="onAddOrUpdateCondition()">
            Update condition <mat-icon fontIcon="update"></mat-icon>
          </button>
        }
      </section>
    }
  </section>
